import { setSort } from "./sort/setSort";
import { setColor } from "./resize/setColor";
import { setDimensionType } from "./resize/setDimensionType";
import { setDPI } from "./resize/setDPI";
import { setHeight } from "./resize/setHeight";
import { setIsLocked } from "./resize/setIsLocked";
import { setPercentage } from "./resize/setPercentage";
import { setSocialMediaPlatform } from "./resize/setSocialMediaPlatform";
import { setSocialMediaPlatformPreset } from "./resize/setSocialMediaPlatformPreset";
import { setShouldFillColor } from "./resize/setShouldFillColor";
import { setUnit } from "./resize/setUnit";
import { setWidth } from "./resize/setWidth";
import { setFillColorType } from "./resize/setFillColorType";
import { deleteImage } from "./images/deleteImage";
import { addImage } from "./images/addImage";
import { deleteAllImages } from "./images/deleteAllImages";
import { setImages } from "./images/setImages";
import { setDimension } from "./images/setDimension";
import { setImageState } from "./images/setImageState";
import { setImporting } from "./images/setImporting";
import { setIsCorrupted } from "./images/setIsCorrupted";
import { setFileUnit } from "./export/setFileUnit";
import { setMaxFileSize } from "./export/setMaxFileSize";
import { setOptimizationLevel } from "./export/setOptimizationLevel";
import { setSaveAs } from "./export/setSaveAs";
import { reset } from "./reset";
import { setHeight as cropSetHeight } from "./images/crop/setHeight";
import { setWidth as cropSetWidth } from "./images/crop/setWidth";
import { setRatio as cropSetRatio } from "./images/crop/setRatio";
import { toggleCropOrientation as cropToggleCropOrientation } from "./images/crop/toggleCropOrientation";
import { setLeft as cropSetLeft } from "./images/crop/setLeft";
import { setTop as cropSetTop } from "./images/crop/setTop";
import { reset as cropReset } from "./images/crop/reset";
import { setCustomRatioX as cropSetCustomRatioX } from "./images/crop/setCustomRatioX";
import { setCustomRatioY as cropSetCustomRatioY } from "./images/crop/setCustomRatioY";
import { setCropBox as cropSetCropBox } from "./images/crop/setCropBox";
import { handleCropBoxChange as cropHandleCropBoxChange } from "./images/crop/handleCropBoxChange";
import { setPreview as cropSetPreview } from "./images/crop/setPreview";
import { toggleHorizontal as flipToggleHorizontal } from "./images/flip/toggleHorizontal";
import { toggleVertical as flipToggleVertical } from "./images/flip/toggleVertical";
import { reset as flipReset } from "./images/flip/reset";
import { setRotation as rotateSetRotation } from "./images/rotate/setRotation";
import { setStraighten as rotateSetStraighten } from "./images/rotate/setStraighten";
import { setInitialData as rotateSetInitialData } from "./images/rotate/setInitialData";
import { reset as rotateReset } from "./images/rotate/reset";
import { addOperation } from "./images/operations/addOperation";
import { deleteAllOperations } from "./images/operations/deleteAllOperations";
import { setOriginal } from "./images/setOriginal";
import { setPreview } from "./images/setPreview";
import { setEditImageModal } from "./setEditImageModal";

export const reducers = {
    setColor,
    setDimensionType,
    setDPI,
    setHeight,
    setIsLocked,
    setPercentage,
    setSocialMediaPlatform,
    setSocialMediaPlatformPreset,
    setShouldFillColor,
    setUnit,
    setWidth,
    setFillColorType,
    // filter
    setSort,
    // images
    addImage,
    deleteImage,
    deleteAllImages,
    setImages,
    setDimension,
    setImageState,
    setImporting,
    setIsCorrupted,
    // export settings,
    setFileUnit,
    setMaxFileSize,
    setOptimizationLevel,
    setSaveAs,
    reset,
    // crop
    cropSetWidth,
    cropSetHeight,
    cropSetRatio,
    cropToggleCropOrientation,
    cropSetLeft,
    cropSetTop,
    cropSetCropBox,
    cropReset,
    cropHandleCropBoxChange,
    cropSetCustomRatioX,
    cropSetCustomRatioY,
    cropSetPreview,
    // flip
    flipToggleHorizontal,
    flipToggleVertical,
    flipReset,
    //rotate
    rotateSetRotation,
    rotateSetStraighten,
    rotateReset,
    rotateSetInitialData,
    // operations
    addOperation,
    deleteAllOperations,
    setOriginal,
    setPreview,
    setEditImageModal,
};
